import { render, staticRenderFns } from "./LoyaltyReferralLinkSharer.vue?vue&type=template&id=c8cf0c24&scoped=true&"
import script from "./LoyaltyReferralLinkSharer.vue?vue&type=script&lang=js&"
export * from "./LoyaltyReferralLinkSharer.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyReferralLinkSharer.vue?vue&type=style&index=0&id=c8cf0c24&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cf0c24",
  null
  
)

export default component.exports